import React, { SVGProps } from 'react';

const SvgFahrenheit = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg viewBox='0 0 24 24' className='svg-icon' {...props}>
			<g fill='none' fillRule='evenodd'>
				<path d='M0 0h24v24H0z' />
				<path fill='currentColor' d='M11.604 6H20v2h-6v3.728h5.488v1.908H14V19h-2.396z' />
				<path
					d='M3.72 8.92c0-.396.075-.768.225-1.116a2.92 2.92 0 011.539-1.539c.348-.15.72-.225 1.116-.225.396 0 .768.075 1.116.225a2.92 2.92 0 011.539 1.539c.15.348.225.72.225 1.116 0 .396-.075.768-.225 1.116a2.92 2.92 0 01-1.539 1.539c-.348.15-.72.225-1.116.225-.396 0-.768-.075-1.116-.225a2.92 2.92 0 01-1.539-1.539A2.789 2.789 0 013.72 8.92zm1.404 0c0 .408.144.756.432 1.044.288.288.636.432 1.044.432.408 0 .756-.144 1.044-.432.288-.288.432-.636.432-1.044 0-.408-.144-.756-.432-1.044A1.422 1.422 0 006.6 7.444c-.408 0-.756.144-1.044.432a1.422 1.422 0 00-.432 1.044z'
					fill='currentColor'
					opacity={0.3}
				/>
			</g>
		</svg>
	);
};

export default SvgFahrenheit;
